<template>
	<div class="related-products">
		<div class="related-products-container">
			<h2 class="related-products-title">Productos Relacionados</h2>
			<related-products-items
				:currency="currency"
				:products="relatedProducts"
				:translate-value="translateValue"
				@add-quantity="$emit('add-quantity', $event)"
				@change-value="$emit('change-value', $event)"
				@drag="$emit('drag', $event)"
				@sub-quantity="$emit('sub-quantity', $event)"
			></related-products-items>
		</div>
	</div>
</template>

<script>
	import relatedProductsItems from '@/components/market-place/product-detail/related-products-items';

	export default {
		name: 'related-products',
		components: {
			relatedProductsItems,
		},
		props: {
			currency: String,
			relatedProducts: {
				default: () => [],
				type: Array,
			},
			translateValue: [Number, String],
		},
	};
</script>

<style lang="scss" scoped>
	.related-products {
		background-color: color(newbackground);
		padding: 29px 15px 32px;
		text-align: center;

		@media (min-width: 936px) {
			padding: 49px 0px 62px;
		}

		&-container {
			margin: 0 auto;
			max-width: 1200px;
		}

		&-title {
			color: color(primary);
			font-size: size(large22);
			font-weight: weight(black);
			margin-bottom: 49px;
			text-transform: uppercase;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/product-detail/related-products.vue